module.exports = __webpack_public_path__ + "static/media/home_icon_white.2061504b.svg";